import { styled, Typography } from "@mui/material";

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: "24px",
  fontWeight: 600,
  marginBottom: "24px",
  color: theme.palette.text.primary,
}));
